export const baseName = (action) => {
  return action.split('/')[1];
};
